<template>
  <v-layout justify-center>
        <v-flex xs12 sm5 md4 lg3 xl2>
          <v-card>
            <v-img
                gradient="to bottom left, rgba(42,76,100,.3), rgba(42,76,100,.5)"
                class="black--text"
                height="250px"
                :src="info[0].wallpaper !== null ? info[0].wallpaper : info[0].logo"></v-img>
            <v-avatar tile size="90"
                style="
                position: absolute;
                margin-left: 0;
                margin-right: 0;
                left: 0;
                right: 100%;
                top: 0;
                text-align: center;"
            >
              <v-img contain :src="info[0].logo" ></v-img>
            </v-avatar>
            <v-avatar size="150px"
                style="
                position: absolute;
                margin-left: auto;
                margin-right: auto;
                left: 0;
                right: 0;
                top: 20%;
                text-align: center;"
            >
              <v-img :src="info[0].avatar" ></v-img>
            </v-avatar>
            <v-card-text>
              <v-card-title class="justify-center">
                <v-layout row class="text-xs-center">
                  <v-flex class="justify-center mt-2">
                    <div class="headline black--text"><strong>{{info[0].first_name}}</strong></div>
                    <div class="subheading black--text">{{info[0].last_name}}</div>
                    <div class="black--text"><strong>{{info[0].position}}</strong></div><br>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-btn icon large color="primary" :href="`mailto: ${info[0].email}`"><v-icon medium>email</v-icon></v-btn>
                        <br>
                        <div class="subheading black--text">E-Mail</div>
                      </v-flex>
                      <v-flex xs4>
                        <v-btn icon large color="primary" :href="`tel:${info[0].celular}`"><v-icon medium>phone</v-icon></v-btn>
                        <br>
                        <div class="subheading black--text">{{$t('celular')}}</div>
                      </v-flex>
                      <v-flex xs4>
                        <v-btn icon large color="primary" :href="`https://wa.me/${info[0].celular}`"><v-icon medium>whatsapp</v-icon></v-btn>
                        <br>
                        <div class="subheading black--text">Whatsapp</div>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn @click="downloadVCard(info[0])" color="primary">Descargar Contacto<v-spacer/><v-icon>file_download</v-icon></v-btn>
                        <br>
                        {{info[0].company_name}}
                        <br>
                        <a :href="info[0].page">{{info[0].page}}</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-title>
            </v-card-text>
          </v-card>
          <v-spacer/>
        </v-flex>
      </v-layout>
</template>

<script>
export default {
  name: "business_card",
  data () {
    return {
      info: [],
      dialog_bloqueo: false
    }
  },
  async created (){
    await this.getInfo()
  },
  methods:{
    getInfo(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/get_user_business_card/' + this.$route.params['id'] + '/',
        headers: {
          'Content-Type': 'application/json',
        }
      }
      axios(config)
          .then(result => {
            this.info = result.data
            console.log(this.info)
            if (this.info.length === 0) {
              this.dialog_bloqueo = true
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    downloadVCard (dataUSer) {
      var vCardsJS = require('vcards-js')
      var vCard = vCardsJS()

      //set properties
      vCard.firstName = dataUSer.first_name
      vCard.lastName = dataUSer.last_name
      vCard.organization = dataUSer.company_name
      vCard.workPhone = dataUSer.celular
      vCard.workEmail = dataUSer.email
      vCard.title = dataUSer.position
      // console.log(vCard.getFormattedString())
      const a = document.createElement("a")
      const archivo = new Blob([vCard.getFormattedString()], { type: 'text/vcard' })
      const url = URL.createObjectURL(archivo)
      a.href = url
      a.download = dataUSer.first_name + ' ' +dataUSer.last_name + '.vcf'
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>

</style>